import React from 'react';
import ImageLightbox from '../../../components/imageLightbox/ImageLightbox';
import { useImageLightbox } from '../../../components/imageLightbox/useImageLightbox';
import {
  CaseStudyContentCard,
  CaseStudyDoubleCardRow,
  CaseStudyFindingBlock,
  CaseStudyFindingHeader,
} from '../../../components/cards/caseStudyCards/caseStudyCards';
import cards from '../../../components/cards/caseStudyCards/caseStudyCards.module.scss';
import d from './cdDesignSection.module.scss';

import cdDesign1Before from '../../../assets/images/cd/2-design-before.png';
import cdDesign1Before720 from '../../../assets/images/cd/2-design-before-720.png';
import cdDesign1After from '../../../assets/images/cd/2_design_1_after.gif';
import design1Graphic from '../../../assets/images/cd/2-design-1-graphic.png';
import filterDiscoveryFlow from '../../../assets/images/cd/2-design-2-filter flow.png';
import filterDiscoveryMidFi from '../../../assets/images/cd/2-design-2-filter mid fi.png';
import filterDiscoveryMockup from '../../../assets/images/cd/2-design-2-filter mockup.png';
import designSystemButtonInconsistency from '../../../assets/images/cd/3-deign-3-buttons.png';
import campusDiveBrandOverview from '../../../assets/images/cd/Frame 47764.png';
import design3Before from '../../../assets/images/cd/3-design-3-before.png';
import design3After from '../../../assets/images/cd/3_design_3_after.gif';
import sectionDivider from '../../../assets/images/conditionsCaseStudy/designFinding/section_divider.svg';

function SectionDivider() {
  return (
    <div className={d.divider} aria-hidden>
      <img className={d.dividerImg} src={sectionDivider} alt="" />
    </div>
  );
}

export function Finding1BeforeAfterArrow() {
  return (
    <svg
      className={d.beforeAfterFlowArrowSvg}
      width="127"
      height="119"
      viewBox="0 0 127 119"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M103.915 37.3718C102.2 37.3424 101.129 37.2805 100.061 37.3206C98.2306 37.4121 96.3936 37.6921 94.5628 37.6528C92.9949 37.6069 91.6093 36.9662 91.1659 35.1852C90.7609 33.5818 91.488 32.2778 93.3215 31.3729C93.7222 31.1745 94.1741 31.0385 94.6069 30.9445C99.2106 30.0133 103.785 28.9489 108.425 28.2241C113.596 27.4283 115.649 29.1425 116.633 34.3255C117.566 39.1845 117.655 44.03 116.888 48.8464C116.553 50.9536 116.243 53.2227 113.727 54.3748C109.707 50.9535 112.074 46.026 110.497 41.7225C109.712 42.237 108.968 42.5079 108.545 43.0386C100.76 52.9687 91.3925 61.2682 81.2585 68.6017C72.0571 75.2734 62.3165 81.1585 51.0096 83.9613C35.4933 87.816 20.4548 86.0452 5.82045 79.0495C4.57606 78.4499 3.41489 77.6249 2.2826 76.8024C1.16313 75.9954 0.444351 74.9901 1.37632 73.1515C2.6943 73.4813 4.09888 73.8185 5.48103 74.2264C10.4709 75.7251 15.4064 77.5825 20.4794 78.7251C36.2532 82.2726 50.8818 79.3305 64.4976 71.4644C72.3857 66.9185 80.0298 61.9451 86.7306 55.7584C91.89 50.9953 96.6868 45.8237 101.602 40.7639C102.359 39.9855 102.852 38.9523 103.912 37.4006L103.915 37.3718Z"
        fill="#F8C83C"
      />
    </svg>
  );
}

/** Mirrored path from conditions disability design section (`FindingAsthmaArrow`): use when AFTER is left and BEFORE is right. */
export function FindingBeforeAfterArrowMirrored() {
  return (
    <svg
      className={d.beforeAfterFlowArrowSvg}
      width="127"
      height="119"
      viewBox="0 0 127 119"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M22.6687 37.3718C24.3841 37.3424 25.455 37.2805 26.5227 37.3206C28.3534 37.4121 30.1904 37.6921 32.0212 37.6528C33.5891 37.6069 34.9746 36.9662 35.4181 35.1852C35.8231 33.5818 35.096 32.2778 33.2625 31.3729C32.8618 31.1745 32.4099 31.0385 31.9771 30.9445C27.3734 30.0133 22.7986 28.9489 18.1595 28.2241C12.9882 27.4283 10.9352 29.1425 9.95107 34.3255C9.01843 39.1845 8.92907 44.03 9.6958 48.8464C10.0312 50.9536 10.3409 53.2227 12.8572 54.3748C16.8767 50.9535 14.51 46.026 16.0868 41.7225C16.872 42.237 17.6158 42.5079 18.0387 43.0386C25.8242 52.9687 35.1915 61.2682 45.3255 68.6017C54.5269 75.2734 64.2675 81.1585 75.5744 83.9613C91.0907 87.816 106.129 86.0452 120.764 79.0495C122.008 78.4499 123.169 77.6249 124.301 76.8024C125.421 75.9954 126.14 74.9901 125.208 73.1515C123.89 73.4813 122.485 73.8185 121.103 74.2264C116.113 75.7251 111.178 77.5825 106.105 78.7251C90.3307 82.2726 75.7022 79.3305 62.0864 71.4644C54.1983 66.9185 46.5542 61.9451 39.8534 55.7584C34.694 50.9953 29.8972 45.8237 24.9816 40.7639C24.2254 39.9855 23.7322 38.9523 22.6718 37.4006L22.6687 37.3718Z"
        fill="#F8C83C"
      />
    </svg>
  );
}

/** Reusable # mark for finding headers (pair with digit SVGs for 2–5 later). */
export function FindingHashSvg() {
  return (
    <svg
      className={cards.findingMarkHashSvg}
      width="30"
      height="33"
      viewBox="0 0 30 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M2.38528 20.467C3.7552 19.9793 5.12512 19.462 6.48062 18.93C6.84112 20.3636 7.23045 21.7824 7.63422 23.2012C6.04799 24.0732 4.34642 24.8122 3.09186 26.1571C3.1928 26.8813 3.5533 27.5612 4.13011 28.0193C5.80286 27.9306 7.37469 27.3395 8.97533 26.8961C9.84055 29.1278 10.475 31.9359 12.8399 33C15.003 31.0343 14.8876 27.842 13.9792 25.2556C15.9836 24.5609 17.9591 23.7628 19.9203 22.9352C21.1748 25.0634 22.4871 27.2804 24.3617 28.9061C25.6307 29.8372 26.2219 27.7829 26.6401 26.8961C27.7072 24.7678 27.1304 22.3588 26.4815 20.2158C28.8608 18.9743 29.8125 16.3288 30 13.7571C28.01 12.959 25.9479 13.5206 24.0589 14.2892C23.6118 13.1068 23.1648 11.9245 22.7034 10.7421C25.5009 9.97358 26.4815 7.01768 26.7122 4.37216C26.0489 4.03223 25.3711 3.67751 24.7366 3.3228C23.2081 3.66273 21.7228 4.01745 20.2231 4.41649C19.3146 2.86465 18.8964 0.49993 16.9497 0.0269863C15.277 -0.224265 14.4262 1.32758 13.907 2.65773C14.1522 4.1209 14.729 5.4806 15.176 6.89944C13.1428 8.05223 11.1383 9.24938 9.13393 10.4613C8.41292 8.76165 7.63423 7.06201 6.88438 5.37715C6.12011 5.15546 5.34144 4.93377 4.56275 4.84509C4.00036 4.9781 2.93325 4.90422 3.29376 5.80577C3.69753 8.18526 4.44736 10.4761 4.93764 12.8408C3.35142 13.7571 1.59217 14.437 0.222245 15.708C-0.642968 17.5111 1.21724 19.2699 2.38528 20.467ZM17.1948 13.3285C17.5842 14.6587 17.988 16.0036 18.3773 17.3485C16.4162 18.4274 14.455 19.5359 12.5227 20.6591C12.1045 19.2847 11.6863 17.9249 11.2825 16.5652C13.2581 15.5011 15.2193 14.4074 17.1948 13.3285Z"
        fill="#05494F"
      />
    </svg>
  );
}

function FindingDigitOneSvg() {
  return (
    <svg
      className={cards.findingMarkSvg}
      width="30"
      height="54"
      viewBox="0 0 30 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M29.8943 1.59422C29.7816 -0.0182768 27.781 -0.564885 26.7666 0.692313C26.4285 1.07494 26.0622 1.43023 25.6959 1.78553C25.6395 1.78553 25.6113 1.78553 25.555 1.78553C21.3848 4.68255 17.44 9.73867 13.467 13.1823C9.94481 16.7353 6.16907 20.2062 3.01322 24.1145C2.47785 24.6064 1.94248 25.1257 1.43529 25.6176C1.01264 26.0003 0.928104 26.4649 1.04081 26.8748C0.787218 27.2575 0.477268 27.6127 0.223673 27.9954C-0.480757 29.0886 0.589977 30.5371 1.88613 30.2365C3.09775 29.6079 4.22484 28.8153 5.29557 27.9407C5.74641 28.5966 6.78897 28.8426 7.43704 28.214C7.63428 28.05 7.74699 27.8314 7.80335 27.6127C7.80335 27.7767 7.77517 27.8861 7.66246 27.968C11.2128 23.9505 15.0731 20.2062 18.9615 16.5166C20.6522 14.9314 22.2583 13.2643 23.8644 11.5971C23.1036 15.2594 22.1737 19.359 21.6947 22.8573C20.7085 28.2687 20.2577 33.7621 20.0604 39.2282C19.6096 42.4805 19.3842 45.7875 19.5814 48.9851C19.5814 50.2423 20.3422 50.8163 21.103 50.8163C21.103 51.0896 21.0466 51.3902 21.0466 51.6635C21.0466 51.7455 21.0466 51.8001 21.0466 51.8548C21.0466 52.1008 21.0185 52.3468 20.9903 52.5927C20.9621 53.2487 21.4693 53.9046 22.1455 53.9866C22.9345 54.0686 23.3572 53.7679 23.6108 53.276C24.118 53.4673 24.7097 53.44 25.1042 53.0573C27.0766 44.011 26.7666 34.2267 28.0064 24.9617C28.5418 17.1999 30.3169 9.41071 29.9506 1.62155L29.8943 1.59422Z"
        fill="#05494F"
      />
    </svg>
  );
}

function FindingMarkOne() {
  return (
    <>
      <FindingHashSvg />
      <FindingDigitOneSvg />
    </>
  );
}

function FindingMarkTwo() {
  return (
    <svg
      className={cards.findingMarkTwoSvg}
      width="70"
      height="42"
      viewBox="0 0 70 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M2.38528 24.4882C3.7552 24.0005 5.12512 23.4833 6.48062 22.9512C6.84112 24.3848 7.23045 25.8036 7.63422 27.2225C6.04799 28.0945 4.34642 28.8334 3.09186 30.1784C3.1928 30.9026 3.5533 31.5824 4.13011 32.0406C5.80286 31.9519 7.37469 31.3607 8.97533 30.9173C9.84055 33.149 10.475 35.9571 12.8399 37.0212C15.003 35.0556 14.8876 31.8632 13.9792 29.2768C15.9836 28.5822 17.9591 27.7841 19.9203 26.9564C21.1748 29.0847 22.4871 31.3016 24.3617 32.9273C25.6307 33.8584 26.2219 31.8041 26.6401 30.9173C27.7072 28.7891 27.1304 26.38 26.4815 24.237C28.8608 22.9955 29.8125 20.35 30 17.7784C28.01 16.9803 25.9479 17.5419 24.0589 18.3104C23.6118 17.1281 23.1648 15.9457 22.7034 14.7633C25.5009 13.9948 26.4815 11.0389 26.7122 8.3934C26.0489 8.05347 25.3711 7.69875 24.7366 7.34404C23.2081 7.68397 21.7228 8.03869 20.2231 8.43773C19.3146 6.88589 18.8964 4.52117 16.9497 4.04823C15.277 3.79698 14.4262 5.34882 13.907 6.67897C14.1522 8.14214 14.729 9.50184 15.176 10.9207C13.1428 12.0735 11.1383 13.2706 9.13393 14.4825C8.41292 12.7829 7.63423 11.0833 6.88438 9.39839C6.12011 9.1767 5.34144 8.95501 4.56275 8.86633C4.00036 8.99934 2.93325 8.92546 3.29376 9.82701C3.69753 12.2065 4.44736 14.4973 4.93764 16.862C3.35142 17.7784 1.59217 18.4582 0.222245 19.7293C-0.642968 21.5324 1.21724 23.2911 2.38528 24.4882ZM17.1948 17.3498C17.5842 18.6799 17.988 20.0248 18.3773 21.3698C16.4162 22.4487 14.455 23.5571 12.5227 24.6804C12.1045 23.3059 11.6863 21.9462 11.2825 20.5865C13.2581 19.5223 15.2193 18.4287 17.1948 17.3498Z"
        fill="#05494F"
      />
      <path
        d="M69.4843 34.6097C68.968 34.3074 68.3534 34.4004 67.788 34.3307C67.7388 34.3307 67.6651 34.3307 67.6159 34.3307C67.6159 34.3307 67.6159 34.3074 67.6159 34.2842C67.8863 31.5634 62.2321 33.9121 60.5604 33.8656C59.0608 34.0749 57.4136 34.3539 55.7419 34.6795C51.7594 35.0748 48.0472 35.6329 45.8347 35.912C47.0639 34.6562 48.9814 33.2842 50.5302 32.0518C53.7752 29.4938 57.1924 26.8893 59.282 23.3314C61.5683 19.3317 62.6254 14.7971 63.2892 10.3322C63.6088 8.05331 63.24 6.14646 62.3796 4.61168C62.0846 3.70476 61.6912 2.8211 61.0275 2.0072C59.2574 0.51892 56.8236 -0.0391842 54.4882 0.0770873C52.3986 -0.132201 50.1614 0.0770872 47.9981 0.797971C46.4493 1.28631 40.6229 2.3095 43.4009 4.51866C43.8434 4.61168 44.3105 4.61168 44.753 4.58842C44.6055 4.7512 44.458 4.89073 44.3351 5.07676C44.0647 5.63487 43.6713 6.3325 44.0155 6.93711C44.4826 7.84403 45.9822 7.7045 46.2772 6.75107C46.523 5.68138 48.0964 4.56517 49.891 3.72801C54.2423 3.14666 59.1345 3.49547 59.7983 5.84416C60.1424 6.70457 60.2408 7.58823 60.2162 8.44864C60.0933 9.49508 59.8474 10.5415 59.4787 11.6345C57.9791 15.1924 54.5865 18.8201 51.8085 22.4245C47.9981 27.3311 43.2288 31.9587 40.6967 37.563C40.6967 37.656 40.6967 37.7258 40.6967 37.7956C40.4017 38.2374 40.1804 38.7025 40.0083 39.1908C39.8608 40.7024 41.7046 41.2372 42.983 40.9814C51.5381 39.4466 60.1424 38.0979 68.7468 36.8654C69.976 36.8189 70.4922 35.2376 69.4105 34.6097H69.4843ZM51.2923 28.4008C53.849 25.2848 56.7499 21.6803 59.0116 18.0294C58.2741 20.2618 57.2907 22.285 55.7419 24.2151C54.8078 25.3778 53.1115 26.8893 51.2923 28.4008Z"
        fill="#05494F"
      />
    </svg>
  );
}

function FindingMarkThree() {
  return (
    <svg
      className={cards.findingMarkThreeSvg}
      width="70"
      height="39"
      viewBox="0 0 70 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M2.38528 23.0002C3.7552 22.5125 5.12512 21.9952 6.48062 21.4632C6.84112 22.8968 7.23045 24.3156 7.63422 25.7344C6.04799 26.6064 4.34642 27.3454 3.09186 28.6903C3.1928 29.4145 3.5533 30.0944 4.13011 30.5525C5.80286 30.4639 7.37469 29.8727 8.97533 29.4293C9.84055 31.661 10.475 34.4691 12.8399 35.5332C15.003 33.5675 14.8876 30.3752 13.9792 27.7888C15.9836 27.0941 17.9591 26.296 19.9203 25.4684C21.1748 27.5966 22.4871 29.8136 24.3617 31.4393C25.6307 32.3704 26.2219 30.3161 26.6401 29.4293C27.7072 27.3011 27.1304 24.892 26.4815 22.749C28.8608 21.5075 29.8125 18.862 30 16.2903C28.01 15.4922 25.9479 16.0538 24.0589 16.8224C23.6118 15.64 23.1648 14.4577 22.7034 13.2753C25.5009 12.5068 26.4815 9.55089 26.7122 6.90536C26.0489 6.56543 25.3711 6.21071 24.7366 5.85601C23.2081 6.19594 21.7228 6.55065 20.2231 6.9497C19.3146 5.39785 18.8964 3.03313 16.9497 2.56019C15.277 2.30894 14.4262 3.86078 13.907 5.19093C14.1522 6.6541 14.729 8.01381 15.176 9.43264C13.1428 10.5854 11.1383 11.7826 9.13393 12.9945C8.41292 11.2949 7.63423 9.59521 6.88438 7.91035C6.12011 7.68866 5.34144 7.46697 4.56275 7.37829C4.00036 7.51131 2.93325 7.43742 3.29376 8.33897C3.69753 10.7185 4.44736 13.0093 4.93764 15.374C3.35142 16.2903 1.59217 16.9702 0.222245 18.2412C-0.642968 20.0443 1.21724 21.8031 2.38528 23.0002ZM17.1948 15.8617C17.5842 17.1919 17.988 18.5368 18.3773 19.8817C16.4162 20.9606 14.455 22.0691 12.5227 23.1924C12.1045 21.8179 11.6863 20.4581 11.2825 19.0984C13.2581 18.0343 15.2193 16.9406 17.1948 15.8617Z"
        fill="#05494F"
      />
      <path
        d="M68.979 23.2057C66.1041 18.8736 61.4083 17.0475 56.4443 16.4064C57.4984 15.9984 58.5334 15.5322 59.53 14.9688C67.0815 10.6755 62.5775 2.2638 55.7351 0.554256C51.8827 -0.494783 47.877 0.12687 44.0437 0.923362C42.7596 1.29247 41.1304 1.27304 40.153 2.2638C39.6738 3.00201 40.4021 3.93449 41.2071 3.7985C44.197 3.33226 48.4711 2.49692 51.7869 2.32208C49.6594 2.73004 47.5511 3.37112 45.577 4.24532C44.9062 4.57557 44.1587 4.94468 43.7754 5.62461C43.2962 6.53766 44.5612 7.47014 45.2895 6.75135C47.9536 4.76984 54.1443 3.39054 56.8084 4.03162C57.0384 6.75135 54.1252 9.33509 50.7136 11.6857C48.6819 12.9096 46.5353 14.0946 44.3504 15.4545C43.737 15.8819 42.9321 16.6201 43.3346 17.436C43.5071 17.7857 43.8137 17.9799 44.2162 18.1159C43.7562 18.2713 43.2962 18.4073 42.8362 18.5822C42.5296 18.7376 42.3571 19.0678 42.3379 19.3981C42.2996 20.1946 43.1621 20.6608 43.852 20.35C51.8635 18.4073 65.6632 19.0484 64.8774 26.6054C63.4974 30.7238 56.9618 32.5888 51.7294 34.1041C49.8894 34.5897 48.0111 34.8811 46.1903 35.4056C45.5962 35.6193 44.8679 35.8525 44.6954 36.5518C44.5229 37.1346 44.8487 37.7951 45.4237 37.97C45.6728 38.0865 46.0945 38.0671 45.692 38.0282C53.6077 38.4556 74.7864 35.3668 69.0173 23.2251L68.979 23.2057ZM51.0586 16.0956C50.2536 16.0956 49.4486 16.115 48.6628 16.1538C51.2694 15.2214 53.9335 14.4637 56.6551 13.9975C56.9618 13.9586 57.2301 13.9198 57.4601 13.8809C55.5435 14.8717 53.3585 15.4739 51.0394 16.0956H51.0586ZM60.5458 11.6274C60.5458 11.6274 60.4692 11.6857 60.45 11.7246C59.7984 11.6274 58.955 11.7634 58.4376 11.8217C56.3101 12.0354 54.2018 12.4628 52.1319 13.0262C52.2852 12.9096 52.4385 12.8125 52.5919 12.6959C55.5051 10.8309 58.9742 8.88828 59.8942 5.58575C59.8942 5.48862 59.8942 5.41091 59.8942 5.31378C61.715 7.41186 62.1941 9.95675 60.565 11.6274H60.5458ZM53.0518 35.6776C60.6417 33.5601 70.2056 29.8496 65.6249 22.2538C65.5482 22.1372 65.4332 22.0401 65.3374 21.943C66.2957 22.7783 67.1007 23.7691 67.714 24.9735C69.9756 31.3649 60.9675 34.5703 53.0327 35.697L53.0518 35.6776Z"
        fill="#05494F"
      />
    </svg>
  );
}

const FILTER_DESKTOP_ALT =
  'Desktop mockup of filtered interview results with sidebar accordions, active filter chips, and placeholder result cards';
const FILTER_MIDFI_ALT =
  'Mid-fidelity mobile wireframes: interview list with Filter button and full-screen Filters modal with school and area-of-study options';
const FILTER_FLOW_ALT =
  'User flow diagram for Explore Student Interviews: school name filter states, expanded sidebar filters, and no-results path';

const DESIGN_FINDING1_BEFORE_ALT =
  'Earlier Campus Dive bioengineering profile with dense sidebar majors and long-form academic content';

export default function CdDesignSection() {
  const { image, openLightbox, closeLightbox, closeButtonRef } = useImageLightbox();

  return (
    <div className={d.sectionGap}>
      <header className={d.intro}>
        <p className={d.introKicker}>DESIGN BASED ON FINDINGS</p>
        <h2 className={d.introTitle}>Realigning Product Strategy Around Core User Problems</h2>
      </header>

      <CaseStudyFindingBlock>
        <div className={d.findingStack}>
          <CaseStudyFindingHeader
            mark={<FindingMarkOne />}
            title="Turning Complex Content into Intuitive User Understanding"
          />
          <div
            className={`${d.beforeAfter} ${d.beforeAfterUnevenMocks} ${d.beforeAfterFinding1Laptop}`}
          >
            <div className={d.beforeAfterBottom}>
              <div className={`${d.beforeAfterCol} ${d.beforeAfterColAfter}`}>
                <p className={`${d.mockLabel} `}>AFTER</p>
                <div className={`${d.mockAfter} ${d.mockAfterWide}`}>
                  <img
                    src={cdDesign1After}
                    alt="Campus Dive student profile on a laptop showing the Academic Experience tab with structured tags and interview content"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className={d.beforeAfterFlowArrow}>
                <FindingBeforeAfterArrowMirrored />
              </div>
              <div className={`${d.beforeAfterCol} ${d.beforeAfterColBefore}`}>
                <p className={d.mockLabel}>BEFORE</p>
                <div className={`${d.mockBeforeHero} ${d.mockBeforeElevated}`}>
                  <button
                    type="button"
                    className={d.filterDiscoveryFigOpen}
                    onClick={(e) =>
                      openLightbox({ src: cdDesign1Before, alt: DESIGN_FINDING1_BEFORE_ALT }, e.currentTarget)
                    }
                    aria-label={`View full size: ${DESIGN_FINDING1_BEFORE_ALT}`}
                  >
                    <img
                      src={cdDesign1Before720}
                      srcSet={`${cdDesign1Before720} 720w, ${cdDesign1Before} 1440w`}
                      sizes="(max-width: 900px) min(48vw, 359px), 359px"
                      alt=""
                      width={1440}
                      height={1185}
                      loading="lazy"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CaseStudyDoubleCardRow
            className={cards.doubleRowAlignStart}
            left={
              <CaseStudyContentCard label="What we learned" surface="porcelain">
                <div className={d.cardCopyStack}>
                  <p className={d.cardCopy}>
                    The core product value was buried under walls of text, and a high cognitive load. The
                    interview pages were dense and difficult to navigate.
                  </p>
                  <p className={d.cardCopy}>
                    <strong>
                      Campus Dive&apos;s differentiator, first-hand student interviews, was also its biggest
                      usability issue.
                    </strong>
                  </p>
                  <ul className={d.cardListFlush}>
                    <li>Interviews were long-form and text-heavy</li>
                    <li>Students struggled to scan for relevant information</li>
                    <li>There were no filters or structured navigation</li>
                    <li>Users didn’t know what keywords to search</li>
                  </ul>
                  <p className={d.cardCopy}>We weren&apos;t lacking content. We lacked structure.</p>
                </div>
              </CaseStudyContentCard>
            }
            right={
              <CaseStudyContentCard label="Design decision" surface="porcelain">
                <div className={d.cardCopyStack}>
                  <p className={d.cardCopy}>
                    I focused on reducing cognitive load by restructuring how content was organized and
                    consumed, not just how it looked.
                  </p>
                  <ul className={`${cards.cardList} ${d.cardListTight}`}>
                    <li>
                      <strong>Tabs:</strong> segmented long-form content to reduce text density and clarify
                      information architecture
                    </li>
                    <li>
                      <strong>Text hierarchy:</strong> introduced clear structure to guide scanning and
                      improve readability
                    </li>
                    <li>
                      <strong>Iconography:</strong> replaced repetitive text with visual cues to reduce
                      reading effort
                    </li>
                  </ul>
                </div>
              </CaseStudyContentCard>
            }
          />

          <div className={d.callout}>
            <p className={d.calloutLabel}>IMPACT</p>
            <p className={d.calloutTitle}>
              Shifted the experience from dense and linear to scannable, structured, and
              insight-first making key information faster to find and easier to understand.
            </p>
          </div>

          <figure className={d.designGraphicFigure}>
            <img
              className={d.designGraphicImg}
              src={design1Graphic}
              alt="Campus Dive Neuroscience at Agnes Scott mockup with callouts for tabs, contributor sidebar, highlights card, and interview hierarchy"
              loading="lazy"
            />
          </figure>
        </div>
      </CaseStudyFindingBlock>

      <SectionDivider />
      <CaseStudyFindingBlock>
        <div className={d.findingStack}>
          <CaseStudyFindingHeader
            mark={<FindingMarkTwo />}
            title="Shifting from Search to Guided Discovery to Improve Navigation"
          />
          <CaseStudyDoubleCardRow
            className={`${cards.doubleRowAlignStart} ${d.doubleCardRowNormalLineHeight}`}
            left={
              <CaseStudyContentCard label="What we learned" surface="porcelain">
                <div className={d.cardCopyStack}>
                  <p className={d.cardCopy}>
                    The primary navigation model was a search bar, but search placed too much burden on users
                    to know what to look for:
                  </p>
                  <ul className={`${cards.cardList} ${d.cardListTight}`}>
                    <li>Users didn&apos;t know what to search for</li>
                    <li>The algorithm didn&apos;t return reliable results</li>
                    <li>There was no fallback navigation system</li>
                  </ul>
                  <p className={d.cardCopy}>
                    <strong>This created a brittle experience where failure cascaded quickly.</strong>
                  </p>
                  <p className={d.cardCopy}>
                    <strong>Strategic implication:</strong> If users need to know the answer before searching,
                    search is not solving discovery.
                  </p>
                </div>
              </CaseStudyContentCard>
            }
            right={
              <CaseStudyContentCard label="Design decision" surface="porcelain">
                <div className={d.cardCopyStack}>
                  <p className={d.cardCopy}>
                    We shifted the experience toward guided discovery by structuring how content could be
                    explored.
                  </p>
                  <div className={d.cardCopyStackLeadIn}>
                    <ul className={`${cards.cardList} ${d.cardListTight}`}>
                      <li>
                        <strong>Introduced filters, sorting, and browse patterns:</strong> enabled users to explore
                        content without needing a precise query.
                      </li>
                      <li>
                        <strong>Prioritized high-impact filters:</strong> focused on the most meaningful dimensions
                        to reduce decision fatigue and improve relevance.
                      </li>
                      <li>
                        <strong>Adapted filter interactions by platform</strong>
                        <ul className={d.cardListNestedNoTop}>
                          <li>Desktop: persistent sidebar for continuous refinement</li>
                          <li>Mobile: modal-based filters to preserve screen space</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </CaseStudyContentCard>
            }
          />
          <div className={d.filterDiscoveryGallery}>
            <div
              className={d.filterDiscoveryRow}
              role="group"
              aria-label="Filter exploration: user flow, mobile wireframes, and desktop mockup"
            >
              <figure className={d.filterDiscoveryFig}>
                <button
                  type="button"
                  className={d.filterDiscoveryFigOpen}
                  onClick={(e) =>
                    openLightbox({ src: filterDiscoveryMockup, alt: FILTER_DESKTOP_ALT }, e.currentTarget)
                  }
                  aria-label={`View full size: ${FILTER_DESKTOP_ALT}`}
                >
                  <img src={filterDiscoveryMockup} alt="" loading="lazy" />
                </button>
              </figure>
              <figure className={d.filterDiscoveryFig}>
                <button
                  type="button"
                  className={d.filterDiscoveryFigOpen}
                  onClick={(e) =>
                    openLightbox({ src: filterDiscoveryMidFi, alt: FILTER_MIDFI_ALT }, e.currentTarget)
                  }
                  aria-label={`View full size: ${FILTER_MIDFI_ALT}`}
                >
                  <img src={filterDiscoveryMidFi} alt="" loading="lazy" />
                </button>
              </figure>
              <figure className={d.filterDiscoveryFig}>
                <button
                  type="button"
                  className={d.filterDiscoveryFigOpen}
                  onClick={(e) =>
                    openLightbox({ src: filterDiscoveryFlow, alt: FILTER_FLOW_ALT }, e.currentTarget)
                  }
                  aria-label={`View full size: ${FILTER_FLOW_ALT}`}
                >
                  <img src={filterDiscoveryFlow} alt="" loading="lazy" />
                </button>
              </figure>
            </div>
            <p className={d.filterDiscoveryCaption}>
              Mid-Fidelity Wireframes of Filter Mockup and User Flow
            </p>
          </div>
          <div className={d.callout}>
            <p className={d.calloutLabel}>TRADEOFF</p>
            <p className={d.calloutTitle}>
              Reduced flexibility in favor of clarity, speed, and usability; guiding users to relevant
              content faster without overwhelming them with options.
            </p>
          </div>
        </div>
      </CaseStudyFindingBlock>

      <SectionDivider />

      <CaseStudyFindingBlock>
        <div className={d.findingStack}>
          <CaseStudyFindingHeader
            mark={<FindingMarkThree />}
            title="Defining Product Voice Through a Scalable Design System"
          />
          <CaseStudyDoubleCardRow
            className={cards.doubleRowAlignCenter}
            left={
              <CaseStudyContentCard label="What we learned" surface="porcelain">
                <div className={d.cardCopyStack}>
                  <div className={d.cardCopyStackLeadIn}>
                    <p className={d.cardCopy}>
                      An audit of the existing experience revealed a lack of cohesion across both brand and
                      product:
                    </p>
                    <ul className={`${cards.cardList} ${d.cardListTight}`}>
                      <li>Inconsistent visual language and interaction patterns</li>
                      <li>No unified design system to scale consistency</li>
                      <li>Weak brand expression and differentiation</li>
                      <li>Fragmented experiences across features</li>
                    </ul>
                  </div>
                  <div className={d.cardCopyStackLeadIn}>
                    <p className={d.cardCopy}>
                      In parallel, competitor analysis highlighted a clear gap in the market:
                    </p>
                    <ul className={`${cards.cardList} ${d.cardListTight}`}>
                      <li>Little emphasis on student-centered storytelling</li>
                      <li>Low levels of visual engagement</li>
                      <li>Disconnected product ecosystems</li>
                    </ul>
                  </div>
                </div>
              </CaseStudyContentCard>
            }
            right={
              <div className={d.auditVisualColumn}>
                <figure className={d.auditVisualFig}>
                  <img
                    src={designSystemButtonInconsistency}
                    alt="Collage of seven Campus Dive buttons in mixed styles: varied shapes, teal and coral fills, outline and solid treatments, and inconsistent capitalization"
                    loading="lazy"
                  />
                </figure>
              </div>
            }
          />
          <CaseStudyDoubleCardRow
            className={`${cards.doubleRowAlignCenter} ${d.doubleCardRowMarginBottom120}`}
            left={
              <div className={d.brandOverviewColumn}>
                <figure className={d.brandOverviewFig}>
                  <img
                    src={campusDiveBrandOverview}
                    alt="Campus Dive brand overview: wordmark, color palette strip, typography sample, favorite button states, and octopus mascot illustration"
                    loading="lazy"
                  />
                </figure>
                <p className={d.filterDiscoveryCaption}>Updated Branding Visual Overview</p>
              </div>
            }
            right={
              <CaseStudyContentCard label="Strategic decision & tradeoff" surface="porcelain">
                <div className={d.cardCopyStack}>
                  <p className={d.cardCopy}>
                    This required shifting from fragmented features to a unified, system-driven product
                    experience.
                  </p>
                  <div className={d.cardCopyStackLeadIn}>
                    <ul className={`${cards.cardList} ${d.cardListTight}`}>
                      <li>
                        <strong>Defined foundational design standards:</strong> Established color, typography,
                        and component principles to create a consistent visual language.
                      </li>
                      <li>
                        <strong>Built a shared component library:</strong> Enabled reuse, alignment, and
                        scalability across design and engineering.
                      </li>
                      <li>
                        <strong>Systematized consistency across features:</strong> Applied the system to both new
                        and existing surfaces to eliminate fragmentation.
                      </li>
                    </ul>
                  </div>
                  <p className={d.cardCopy}>
                    This work moved beyond visual polish, it created a scalable foundation for faster, more
                    consistent product development while strengthening overall product clarity and brand
                    cohesion.
                  </p>
                </div>
              </CaseStudyContentCard>
            }
          />
          <div
            className={`${d.beforeAfter} ${d.beforeAfterUnevenMocks} ${d.beforeAfterWideAfterRow}`}
          >
            <div className={d.beforeAfterBottom}>
              <div className={`${d.beforeAfterCol} ${d.beforeAfterColBefore}`}>
                <p className={d.mockLabel}>BEFORE</p>
                <div className={d.mockBeforeHero}>
                  <img
                    src={design3Before}
                    alt="Earlier Campus Dive hero with dimmed student scene behind text, headline, and two stacked orange call-to-action buttons"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className={d.beforeAfterFlowArrow}>
                <Finding1BeforeAfterArrow />
              </div>
              <div className={`${d.beforeAfterCol} ${d.beforeAfterColAfter}`}>
                <p className={d.mockLabel}>AFTER</p>
                <div className={`${d.mockAfter} ${d.mockAfterWide}`}>
                  <img
                    src={design3After}
                    alt="Campus Dive on a laptop: redesigned landing page, login flow, and interview library with search and topic filter tags"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={d.callout}>
            <p className={d.calloutLabel}>STRATEGIC SHIFT</p>
            <p className={d.calloutTitle}>
              Differentiate through clarity, cohesion, and emotional resonance, not just functionality.
            </p>
          </div>
        </div>
      </CaseStudyFindingBlock>

      <ImageLightbox
        image={image}
        onClose={closeLightbox}
        closeButtonRef={closeButtonRef}
      />
    </div>
  );
}
